import { render, staticRenderFns } from "./productsComponent.vue?vue&type=template&id=c3df7d40&scoped=true&"
import script from "./productsComponent.vue?vue&type=script&lang=js&"
export * from "./productsComponent.vue?vue&type=script&lang=js&"
import style0 from "./productsComponent.vue?vue&type=style&index=0&id=c3df7d40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3df7d40",
  null
  
)

export default component.exports